
/* eslint-disable no-magic-numbers */
import { computed, reactive, defineComponent, PropType, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Message } from '../../message-push.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { DetailQueryParams, CommandStatService } from './detail-drawer.service'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import Keywords from '@/views/dashboard/data-safe/anti-external-control/components/Keywords.vue'

export default defineComponent({
  components: {
    ContentAdaptLayout,Keywords,
    IPColumn
  },
  props: {
    modelValue: { // visible 是否显示
      type: Boolean,
      default: false,
    },
    row: {
      type: Object as PropType<Message>,
      required: true,
    },
    type: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'update'],
  setup (props, ctx) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([CommandStatService])
    const service = injector.get(CommandStatService)

    const state = reactive({
      tabActive: 'sending',
      // 加载完数据
      status: true,
      // 表格数据
      tableData: [],
      total: 0,
    })

    const query = reactive<DetailQueryParams>({
      page: 1,
      limit: 10,
      status: 0
    })
    function parseArrayOnly(str) {
      try {
        const parsed = JSON.parse(str)
        return Array.isArray(parsed) ? parsed : null
      } catch (e) {
        return null
      }
    }
    async function getTableData (isOperatePage:boolean = false) {
      !isOperatePage && (query.page = 1)
      state.status = true
      query.task_id = (props.row as Message).task_id
      const res = await service.get(query)
      state.tableData = res.list
      state.total = res.total
      state.status = false
    }

    function getListByPage (page: number) {
      query.page = page
      query.task_id = (props.row as Message).task_id
      getTableData(true)
    }

    const count = reactive({
      sending: 0,
      finish: 0,
      failed: 0,
    })

    watch(() => (props.row as Message).task_id, (v) => {
      if (v) {
        getTableData()
        count.sending = (props.row as Message).unexecuted_count
        count.finish = (props.row as Message).success_count
        count.failed = (props.row as Message).failed_count
      }
    })

    const tabs = computed(() => {
      void locale.value
      return [
        {
          name: 'sending',
          label: t('noticeManage.deliverTabSendingCount', { count: count.sending })
        },
        {
          name: 'finish',
          label: t('noticeManage.deliverTabSuccessCount', { count: count.finish })
        },
        {
          name: 'failed',
          label: t('noticeManage.deliverTabFailedCount', { count: count.failed })
        }
      ]
    })

    async function handleEvent (action: string) {
      switch (action) {
        case 'close':
          ctx.emit('update:modelValue', false)
          break
        case 'finish':
          query.status = 1
          await getTableData()
          count.finish = state.total
          ctx.emit('update', props.row, 'success_count', state.total)
          break
        case 'failed':
          query.status = 2
          await getTableData()
          count.failed = state.total
          ctx.emit('update', props.row, 'failed_count', state.total)
          break
        case 'sending':
          query.status = 0
          await getTableData()
          count.sending = state.total
          ctx.emit('update', props.row, 'unexecuted_count', state.total)
          break
      }
    }

    return {
      props,
      query,
      state,
      tabs,parseArrayOnly,
      handleEvent,
      getListByPage,
      getTableData,
      tabClick (e: any) {
        handleEvent(e.props.name)
      }
    }
  }
})

